import IntegrationNew from "./IntegrationNew";

export default IntegrationNew;
